import React from 'react';
import ARSCatalog from './ARSCatalog';

/**
 * Versione SPA di ARSCatalog che include la gestione integrata del dettaglio prodotto
 * Questo componente sostituisce la navigazione tra route separate con una gestione interna
 */
const ARSCatalogSPA = () => {
    return <ARSCatalog />;
};

export default ARSCatalogSPA; 